import { Arrange } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectCommentsEnabled, selectEmojiEnabled } from 'selectors/video';

import CommentButton from 'components/ui-components/comment-button';
import EmojiReactionSet from 'components/ui-components/emoji-reaction-bar';

// This is a set of emoji reactions + comment button, which will show/hide
// depending on whether the video has comments/reactions enabled

const EndScreenReactionGroup = props => {
  const emojiEnabled = useSelector(selectEmojiEnabled);
  const commentsEnabled = useSelector(selectCommentsEnabled);

  const { size, withComment } = props;

  const drawCommentButton = withComment && commentsEnabled;

  return (
    <Arrange justifyContent="center" gap="xsmall">
      {emojiEnabled && <EmojiReactionSet size={size} />}
      {drawCommentButton && (
        <CommentButton
          size={size}
          buttonText={emojiEnabled ? null : 'Leave a Comment'}
        />
      )}
    </Arrange>
  );
};

export default EndScreenReactionGroup;
